/* src/app/components/github/github.component.scss */
.badge {
  margin-right: 10px;
}
.card {
  font-family: "Quicksand", sans-serif;
}
.fol {
  color: white !important;
}
.click {
  cursor: pointer;
}
/*# sourceMappingURL=github.component.css.map */
